import { gradeFilterFactory } from '@/catalog/constants/filterInputMeta/gradeFilterFactory';

export default gradeFilterFactory({
  id: 'brilliance.gmc2',
  name: 'Brilliance v2 Grade',
  getter(filters) {
    return filters.brillianceGmc2;
  },
  setter(value, filters) {
    return filters.setBrillianceGmc2(value);
  },
  showTitle: true,
});
